import React from 'react'
import { Box, Typography } from '@mui/material'

import { isAnalyzerLoading } from 'Pages/AnalyzersV2/@signals'
import { buildVerdict } from 'Pages/AnalyzersV2/@components/PositionVerdict/@utils'
import { dsColorNew } from '@palette'


const textSx = { fontSize: 14, color: dsColorNew.textDark }
const boldSx = { ...textSx, fontWeight: 700, color: dsColorNew.textTitle }

export default function PositionVerdict({ mainData, mainName }) {
	if (isAnalyzerLoading.value) return null

	const verdict = buildVerdict(mainData, mainName)

	if (!verdict) return null

	const { deltaText, rankText, cheapestText, isOftenCheapest, underText, stanceText } = verdict

	// One sentence on a white card with the app blue edge, as the app's cards
	return <Box sx={{
		px: 2.5, py: 1.75, borderRadius: '12px', backgroundColor: dsColorNew.white,
		border: `1px solid ${dsColorNew.grayBorder}`, borderLeft: `4px solid ${dsColorNew.appBlue}`,
	}}>
		<Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: .5 }}>
			<Typography sx={boldSx}>Read:</Typography>

			<Typography component="span" sx={textSx}>
				{mainName} sits
			</Typography>
			{!!deltaText && <Typography sx={boldSx}>{deltaText}</Typography>}
			<Typography component="span" sx={textSx}>
				vs the blended market average
			</Typography>

			{!!rankText && <>
				<Typography component="span" sx={textSx}>and ranks</Typography>
				<Typography sx={boldSx}>{rankText}</Typography>
			</>}

			{!!cheapestText && <Box component="span" sx={{
				display: 'inline-flex', alignItems: 'center', px: 1, py: 0.25, borderRadius: '10px',
				fontSize: 12, fontWeight: 600, lineHeight: 1.5, whiteSpace: 'nowrap',
				color: isOftenCheapest ? dsColorNew.successText : dsColorNew.dangerRed,
				backgroundColor: isOftenCheapest ? dsColorNew.successBg : dsColorNew.dangerBg,
			}}>
				{cheapestText}
			</Box>}

			<Typography component="span" sx={textSx}>{underText}</Typography>
			{!!stanceText && <Typography component="span" sx={textSx}>{stanceText}</Typography>}
		</Box>
	</Box>
}
